export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://compliance-api-func-dev.azurewebsites.net/api';

export const REGULATORY_API_BASE_URL = 'https://transtar-regulatory-api.azurewebsites.net/api';

export const API_ENDPOINTS = {
  NEWS: `${REGULATORY_API_BASE_URL}/live-feed`,
  NEWS_LATEST_DATE: `${REGULATORY_API_BASE_URL}/live-feed/stats`,
  COMPANIES_VERIFY: '/api/companies/verify',
  HEALTH: '/health',
};

export const APP_ROUTES = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  DASHBOARD_MICA: '/dashboard/mica',
  DASHBOARD_KYB: '/dashboard/kyb',
  DASHBOARD_LIVE_FEED: '/dashboard/live-feed',
  DASHBOARD_TEST: '/dashboard/test',
  DASHBOARD_SETTINGS: '/dashboard/settings',
  DASHBOARD_USER_SETTINGS: '/dashboard/user-settings',
};

export const LOCAL_STORAGE_KEYS = {
  CURRENT_USER: 'currentUser',
  AUTH_TOKEN: 'authToken',
};
